import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesMisc } from "src/app/core/entities/configuracoesMisc";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { Order } from "src/app/core/entities/order";
import { OrderItem } from "src/app/core/entities/orderItem";
import { CartObserver, CartService } from "src/app/core/services/cart-service";
import { InitProvider } from "src/app/core/services/init-provider";
import {
  ObserverPedido,
  PedidoService,
} from "src/app/core/services/pedido-service";
import { isPlatformBrowser } from "@angular/common";
import { ProductService } from "src/app/core/services/product-service";
import { SecurityService } from "src/app/core/services/security-service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
declare var $: any;
import "@angular/localize/init";
import { NewOrderService } from "src/app/modules/order/service/new-order.service";

@Component({
  selector: "gcc-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, ObserverPedido, CartObserver {
  @ViewChild("searchModal") searchModal: ElementRef;
  SITE: ConfiguracoesSite;
  MISC: ConfiguracoesMisc;

  public isSliderSuperior = true;
  public arrSliderSuperior: Array<String>;
  public intervalSliderSuperior = 2000;
  public filters: [];
  public clientes: [];
  public form: FormGroup = new FormGroup({});
  public formOld = {};
  public filtros;
  public products = [];
  public totalElements: number;
  public pageSize: number = 32;
  public fontSizeSliderSuperior = 14;
  public backgroundColorSliderSuperior = "#6b0409";
  public cartClass: string = "cart-content cart-right cart-hidden";
  public toScroll: boolean = true;
  public totalPages: number;
  public page: number = 0;
  public cartTotalItems: Number;
  public menu;
  public gccMenu;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public pedido: Order;
  public busca: string;
  public fadeOutForbidden: boolean = false;
  public showCart: boolean = true;
  public mostraCarrinhoConfig: boolean = true;
  public dropdown: boolean;
  public breadCrumb: any = [];
  public lastElement: string = "";
  public menuDinamico: boolean = false;
  layoutMenu: number = 0;

  public isComum = false;
  public isGestor = false;
  public isAdmin = false;
  public isLogged = false;
  public isPainel = false;
  public newOrderHidden = false;
  public backgroundColor: string;
  public inicializaPedido: boolean = false;

  constructor(
    public securityService: SecurityService,
    public initProvider: InitProvider,
    public router: Router,
    public pedidoService: PedidoService,
    public productService: ProductService,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    public cartService: CartService,
    private newOrderService: NewOrderService
  ) {
    this.dropdown = false;
    this.backgroundColor = Configuracoes.SITE.backgroundColorSliderSuperior;
    this.SITE = Configuracoes.SITE;
    this.MISC = Configuracoes.MISC;
    this.mostraCarrinhoConfig = Configuracoes.mostraCarrinho;
    this.pedidoService.registerObserver(this);
    this.cartService.registerObserver(this);
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.menuDinamico = Configuracoes.menuDinamico;
    this.layoutMenu = Configuracoes.layoutMenu;
    // console.log(this.initProvider.inicializaPedido)
    // console.log(this.initProvider)
    this.initProvider.inicializaPedido$.subscribe((value) => {
      this.inicializaPedido = value;

      // Agora que temos o valor correto, podemos fazer a chamada

      if (value) {
        // Só faz se for true
        this.newOrderService.automaticOrderSelection().subscribe(
          (res) => {

            if (res) {
              this.menu.splice(
                this.menu.indexOf(
                  this.menu.filter((m) => m.link == $localize`/novo-pedido`)[0]
                ),
                1
              );
              this.newOrderHidden = true;
              // this.refreshMenu()
            }
          },
          (error) => console.log(error)
        );
      } else {
        this.pedidoService.allowDelete = true;
      }
    });
  }

  private getFilteredMenu(type: string): any[] {
    return JSON.parse(this.SITE.menu).filter(
      (menu) => menu.type.includes(type) && menu.link !== $localize`/catalogo`
    );
  }
  breadCrumbSave(bc) {
    let arr: any = [];
    bc.toLowerCase().split(">").length
      ? (arr = bc.toLowerCase().split(">"))
      : (arr = "");
    this.lastElement = arr.pop().replace(" ", "");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i] + " > ";
    }
    this.breadCrumb = arr;
    // localStorage.setItem("breadCrumb",this.breadCrumb+this.lastElement)
  }
  public getMenu() {
    let menu = new Map();
    if (!this.isLogged) {
      // menu.set("/catalogo", {
      //   label: $localize`Catálogo`,
      //   link: "/catalogo",
      //   childs: [],
      // });
      this.getFilteredMenu("not-logged-in").forEach((m) => menu.set(m.link, m));
    } else if (this.isComum) {
      if (!this.newOrderHidden) {
        menu.set($localize`/novo-pedido`, {
          label: $localize`Novo Pedido`,
          link: $localize`/novo-pedido`,
          childs: [],
        });
      }
      menu.set($localize`/pedidos`, {
        label: $localize`Meus Pedidos`,
        link: $localize`/pedidos`,
        childs: [],
      });
      // menu.set("/catalogo", {
      //   label: $localize`Catálogo`,
      //   link: "/catalogo",
      //   childs: [],
      // });
      if (this.pedidoService.pedido) {
        menu.set("/checkout", {
          label: $localize`Finalizar Pedido`,
          link: "/checkout",
          childs: [],
        });
        // menu.set("/linkpagamento", {
        //   label: $localize`Pagamento`,
        //   link: "/linkpagamento",
        //   childs: [],
        // });
        this.getFilteredMenu("pedido-selecionado").forEach((m) =>
          menu.set(m.link, m)
        );
      }
      this.getFilteredMenu("comum").forEach((m) => menu.set(m.link, m));
    } else if (this.isGestor) {
      if (!this.newOrderHidden) {
        menu.set($localize`/novo-pedido`, {
          label: $localize`Novo Pedido`,
          link: $localize`/novo-pedido`,
          childs: [],
        });
      }
      menu.set($localize`/pedidos`, {
        label: $localize`Meus Pedidos`,
        link: $localize`/pedidos`,
        childs: [],
      });
      // menu.set("/catalogo", {
      //   label: $localize`Catálogo`,
      //   link: "/catalogo",
      //   childs: [],
      // });
      if (this.pedidoService.pedido) {
        menu.set("/checkout", {
          label: $localize`Finalizar Pedido`,
          link: "/checkout",
          childs: [],
        });
        // menu.set("/linkpagamento", {
        //   label: $localize`Pagamento`,
        //   link: "/linkpagamento",
        //   childs: [],
        // });
        this.getFilteredMenu("pedido-selecionado").forEach((m) =>
          menu.set(m.link, m)
        );
      }
      this.getFilteredMenu("gestor").forEach((m) => menu.set(m.link, m));
    } else if (this.isAdmin) {
      // menu.set("/catalogo", {
      //   label: $localize`Catálogo`,
      //   link: "/catalogo",
      //   childs: [],
      // });
      this.getFilteredMenu("admin").forEach((m) => menu.set(m.link, m));
    } else if (this.isPainel) {
      menu.set($localize`/pedidos`, {
        label: $localize`Meus Pedidos`,
        link: $localize`/pedidos`,
        childs: [],
      });
      // menu.set("/catalogo", {
      //   label: $localize`Catálogo`,
      //   link: "/catalogo",
      //   childs: [],
      // });
      if (this.pedidoService.pedido) {
        menu.set("/checkout", {
          label: $localize`Finalizar Pedido`,
          link: "/checkout",
          childs: [],
        });
        this.getFilteredMenu("pedido-selecionado").forEach((m) =>
          menu.set(m.link, m)
        );
      }
      this.getFilteredMenu("painel").forEach((m) => menu.set(m.link, m));
    }
    return Array.from(menu.values()).concat(
      this.SITE.infoPage
        .filter((i) => i.menuPrincipal)
        .map((i) => {
          return { label: i.label, link: "info/" + i.pageId, childs: [] };
        })
    );
  }
  filtrarPorMenuDinamico(ids) {
    let bc = this.breadCrumb
      .toString()
      .replaceAll(",", "")
      .replaceAll("  >  ", "+")
      .replaceAll("  > ", "")
      .replaceAll(" ", "_");
    let lE = this.lastElement.split(" ").join("_");
    // window.location.href = '/catalogo?departament='+ids[0]
    // this.productService.filtro = {}
    this.productService.menusIds = ids[0];
    this.router.navigate([$localize`/catalogo`], {
      relativeTo: this.activatedRoute,
      queryParams: { departament: ids[0], breadCrumb: bc, lastElement: lE },
      queryParamsHandling: "merge",
    });
    if (this.router.url.split("?")[0] === $localize`/catalogo`) {
      this.productService.refresh();
    }
    // let array = JSON.parse(localStorage.getItem("selectedItem"))
    // let idArr = array.map(arr => arr.items.map(a => a.id))
    // idArr = [].concat(...idArr)
    // this.filters = ids
    this.productService.filtro["menuIds"] = ids;
    // this.selectByPage(0, true);
    if (isPlatformBrowser(this.platformId)) {
      $(window).scrollTop(0);
    }
  }
  public refreshMenu() {
    this.menu = this.getMenu();
    // window.location.href="/catalogo"
  }
  public refreshMenuCatalog() {
    this.search();
    this.menu = this.getMenu();
  }
  public checkArrayNivel(arr: any[], term: string): boolean {
    if (!Array.isArray(arr) || arr.length === 0) {
      return false;
    }

    const item = arr.find((a) => a.titulo === term);

    if (!item || !Array.isArray(item.elementos)) {
      return false;
    }

    return item.elementos.some((e) => e.listar === true);
  }

  public notify(pedido: Order) {
    if (!pedido) {
      delete this.cartTotalItems;
      this.refreshMenu();
      return;
    }
    this.pedido = pedido;
    // console.log(pedido)
    // console.log(pedido.itens.length)
    const resumo = pedido.total_itensresumo?.total_itens;
    this.cartTotalItems =
      resumo != null && Number.isFinite(Number(resumo))
        ? Number(resumo)
        : pedido.itens.reduce((acc, f) => acc + f.quantidade, 0);
    this.refreshMenu();
  }

  public addItems(items: OrderItem[]) {
    setTimeout(() => (this.cartClass += " cart-hidden-fade-long"), 10);
  }

  public cartShow() {
    this.showCart = true;
    if (this.pedido !== undefined && this.pedido.itens)
      this.cartClass = `cart-content cart-right`;
  }

  public cartFadeOut() {
    if (
      !this.fadeOutForbidden &&
      this.cartClass != `cart-content cart-right cart-hidden`
    ) {
      this.cartClass = `cart-content cart-right cart-hidden-fade`;
    }
  }

  public cartOut() {
    this.fadeOutForbidden = false;
    this.showCart = false;
    this.cartClass = `cart-content cart-right cart-hidden`;
  }

  cleanBusca() {
    this.busca = "";
    this.productService.filtro["busca"] = [];
  }

  search() {
    let busca =
      this.productService.filtro["busca"] === undefined
        ? []
        : this.productService.filtro["busca"];
    // if (this.productService.filtro["busca"]) {
    //   this.productService.filtro["busca"] = this.productService.filtro[
    //     "busca"
    //   ].filter((b) => b != this.busca);
    //   this.productService.filtro["busca"].push(this.busca);
    // } else {
    this.productService.filtro = {};
    this.productService.filtroDescr = [];
    this.productService.filtro["menuIds"] = [];
    this.productService.menusIds = undefined;
    if (Configuracoes.acumulafiltrobusca) {
      this.productService.filtro["busca"] = [...busca, this.busca];
    } else {
      this.productService.filtro["busca"] = [this.busca];
    }
    // }
    if (this.router.url.split("?")[0] != $localize`/catalogo`) {
      this.router.navigate([$localize`/catalogo`]);
    } else {
      this.productService.refresh();
    }
    if (isPlatformBrowser(this.platformId)) {
      $("#searchModal").modal("hide");
    }
    if (Configuracoes.limpaBusca) {
      this.busca = "";
    }
  }

  ngOnInit() {
    if (
      Configuracoes.SITE !== undefined &&
      Configuracoes.SITE.backgroundColorSliderSuperior
    ) {
      this.backgroundColorSliderSuperior =
        Configuracoes.SITE.backgroundColorSliderSuperior;
    }
    if (isPlatformBrowser(this.platformId)) {
      $(function () {
        $("body").on("click", "[data-ma-action]", function (e) {
          e.preventDefault();
          let $this = $(this);
          let action = $(this).data("ma-action");
          switch (action) {
            case "submenu-toggle":
              $this.next().slideToggle(200);
              $this.parent().toggleClass("toggled");
              break;
          }
        });
        $("#searchModal").on("shown.bs.modal", function () {
          $("#searchModalField").trigger("focus");
        });
      });
    }
    this.isLogged = this.securityService.hasToken();
    this.isSliderSuperior = Configuracoes.SITE.isSliderSuperior;
    this.intervalSliderSuperior = Configuracoes.SITE.intervalSliderSuperior;
    this.fontSizeSliderSuperior = Configuracoes.SITE.fontSizeSliderSuperior;
    this.backgroundColorSliderSuperior =
      Configuracoes.SITE.backgroundColorSliderSuperior;
    this.arrSliderSuperior = Configuracoes.SITE.sliderSuperior;
    this.isComum = this.securityService.isType("COMUM");
    this.isGestor = this.securityService.isType("GESTOR");
    this.isPainel = this.securityService.isType("PAINEL");
    this.isAdmin = this.securityService.isType("ADMINISTRADOR");
    this.menu = this.getMenu();
  }

  openNav() {
    document.getElementById("myCanvasNav").style.width = "100%";
    document.getElementById("myCanvasNav").style.opacity = "0.8";
    this.openOffcanvas();
  }

  openOffcanvas() {
    document.getElementById("myOffcanvas").style.width = "80%";
  }

  closeOffcanvas() {
    document.getElementById("myOffcanvas").style.width = "0%";
    document.getElementById("myCanvasNav").style.width = "0%";
    document.getElementById("myCanvasNav").style.opacity = "0";
  }

  logout() {
    this.securityService.logout();
  }

  callbackProducts(resp) {
    this.filtros = resp["filtros"];
    let pages = resp["produtos"];
    this.toScroll = true;
    this.totalPages = pages.totalPages;
    this.totalElements = pages.totalElements;
    if (pages.content) {
      if (
        this.pedido &&
        this.productService.visualizacaoModo.startsWith("grade")
      ) {
        // let cli = (this.pedido ? this.pedido.clientes[0].cliente.id + '' : '');

        for (var i = 0; i < pages.content.length; i++) {
          let product = pages.content[i];
          this.products.push(product);

          for (var c = 0; c < this.pedido.clientes.length; c++) {
            let cli = this.pedido.clientes[c].cliente.id;
            let value = "";

            if (this.productService.visualizacaoModo == "gradeClientes") {
              let clienteProduto =
                pages.clientes != null &&
                pages.clientes.filter(
                  (c_) => c_.cliente === cli && c_.produto === product.id
                );

              if (clienteProduto.length > 0)
                value = clienteProduto[0].quantidade;
            } else {
              if (product.quantidade) {
                value = product.quantidade + "";
              }
            }

            let id =
              product.id +
              "@" +
              product.corid +
              "@" +
              product.estampaid +
              "@" +
              product.tamanho +
              "@" +
              cli;

            let fc = new FormControl(value, [Validators.min(0)]);
            if (this.pedido.tipo.validaEstoque) {
              fc = new FormControl(value, [
                Validators.min(0),
                Validators.max(
                  product.estoque < product.quantidademaximadisponivelgrade
                    ? product.estoque
                    : product.quantidademaximadisponivelgrade
                ),
              ]);
            }
            this.form.addControl(id, fc);
            this.formOld[id] = product.quantidade ? product.quantidade : 0;
          }
        }
      } else {
        for (var i = 0; i < pages.content.length; i++) {
          let p = pages.content[i];
          this.products.push(p);
        }
      }
    }
    if (
      this.pedido &&
      this.productService.visualizacaoModo == "gradeClientes"
    ) {
      let clientes: any = [];
      this.pedidoService.pedido.clientes.forEach((pc) => {
        clientes.push(pc.cliente);
      });
      this.clientes = clientes;
    }
  }

  removeBusca() {
    this.productService.filtro = {};
    this.productService.filtroDescr = [];
    this.toScroll = false;
    this.products = [];
  }

  selectByPage(page, force = false) {
    if (!force && page >= this.totalPages) {
      this.toScroll = false;
      return;
    }
    this.page = page;

    if (page == 0) {
      this.products = [];
    }
    this.productService.catalogo(
      page,
      this.pageSize,
      this.callbackProducts.bind(this),
      null
    );
    //this.productService.products(page, this.pageSize, this.filtro, this.ordem, this.direcao, this.callbackProducts.bind(this));
  }
}
